import React from 'react';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import ReactPanZoom from 'react-image-pan-zoom-rotate';

import IconClose from '../atoms/IconClose';
import { wallData } from '../utils';

import Wall1 from '../assets/images/wall-large-1.jpg';
import Wall2 from '../assets/images/wall-large-2.jpg';
import Wall3 from '../assets/images/wall-large-3.jpg';
import Wall4 from '../assets/images/wall-large-4.jpg';
import Wall5 from '../assets/images/wall-large-5.jpg';
import Wall6 from '../assets/images/wall-large-6.jpg';
import Wall7 from '../assets/images/wall-large-7.jpg';
import Wall8 from '../assets/images/wall-large-8.jpg';
import Wall9 from '../assets/images/wall-large-9.jpg';

const WallPhoto = ({ location }) => {

  const [wallId, setWallId] = React.useState(0);

  React.useEffect(() => {
    const parsed = queryString.parse(location.search);
    if (parsed.wall) {
      setWallId(parsed.wall);
    }
    else {
      setWallId(0);
    }
  }, [location.search]);

  const currentWallData = wallData(wallId) || null;

  let wallImage = null;
  switch ( parseInt( wallId ) ) {
    case 1:
      wallImage = Wall1;
      break;

    case 2:
      wallImage = Wall2;
      break;

    case 3:
      wallImage = Wall3;
      break;

    case 4:
      wallImage = Wall4;
      break;

    case 5:
      wallImage = Wall5;
      break;

    case 6:
      wallImage = Wall6;
      break;

    case 7:
      wallImage = Wall7;
      break;

    case 8:
      wallImage = Wall8;
      break;

    case 9:
      wallImage = Wall9;
      break;

    default:
      wallImage = null;
  }

  return (
    <div className="WallPhoto">
      <div className="buttons">
        <Link to={`/wall?wall=${wallId}`}>
          <IconClose/>
        </Link>
      </div>

      <div className="title">
        {currentWallData === null && (
          <p className="h3">
            Loading wall image...
          </p>
        )}
        {currentWallData !== null && (
          <p className="h3">
            {wallData( wallId ).start_letters.toUpperCase()}
            &mdash;
            {wallData( wallId ).end_letters.toUpperCase()}
          </p>
        )}
      </div>

      {wallImage !== null && (
        <div className="WallPhotoContainer">
          <ReactPanZoom
            key={'wall-image'}
            image={wallImage}
            alt={`Full screen image of wall ${wallId}`}
          />
        </div>
      )}
    </div>
  );
};

export default WallPhoto;
